import { useCallback, useEffect } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Badge, IconButton } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import {
    AddonsCartBannerWrapper,
    AddonsCartLeftPart,
    AddonsCartReviewCart,
    AddonsCartRightPart,
} from "app/components/AddonsCart/AddonsCartBanner/StyledAddonsCartBanner";
import { AddonsCartTooltip } from "app/components/AddonsCart/AddonsCartTooltip";
import { useAddonsCart } from "app/components/hooks/useAddonsCart";
import { usePageTopBannerStripReveal } from "app/components/PageTopBanner/bannerRevealContext";
import { translate } from "app/filters/i18nFilter";
import { allTrackers } from "app/services/track/track";

export const AddonsCartBanner = () => {
    const { totalCartItems, onCartClick, onCloseBannerClick, hasAddonsCartBanner, addonsFromCookies } = useAddonsCart();
    const stripProps = usePageTopBannerStripReveal();

    const handleCloseBannerClick = useCallback(() => {
        allTrackers.dispatchTrackEvent("internal link", "close", `cart banner/add ons (${addonsFromCookies})`);
        onCloseBannerClick();
    }, [addonsFromCookies, onCloseBannerClick]);

    const handleCartClick = useCallback(() => {
        allTrackers.dispatchTrackEvent("internal link", "click", `cart banner/add ons (${addonsFromCookies})`);
        onCartClick();
    }, [addonsFromCookies, onCartClick]);

    useEffect(() => {
        if (hasAddonsCartBanner) {
            allTrackers.dispatchTrackEvent("internal link", "show", `cart banner/add ons (${addonsFromCookies})`);
        }
    }, [addonsFromCookies, hasAddonsCartBanner]);

    if (!hasAddonsCartBanner) {
        return null;
    }

    return (
        <AddonsCartBannerWrapper
            {...stripProps}
            data-automation="addons-cart-banner"
        >
            <AddonsCartLeftPart>
                <Text fontVariant="subtitle1">{translate("addons.cart.banner.title")}</Text>
                <AddonsCartTooltip parent="banner">
                    <Badge
                        type="number"
                        bgColor={colorsPalettes.blue[100]}
                    >
                        <Text
                            fontVariant="tag"
                            color={colorsPalettes.blue[400]}
                        >
                            {translate("addons.cart.banner.items.amount", { amount: totalCartItems })}
                        </Text>
                    </Badge>
                </AddonsCartTooltip>
            </AddonsCartLeftPart>
            <AddonsCartRightPart>
                <AddonsCartReviewCart
                    iconName="showcase-shopping"
                    type="inverted"
                    onClick={handleCartClick}
                >
                    {translate("addons.cart.banner.cta.text")}
                </AddonsCartReviewCart>

                <IconButton
                    onClick={handleCloseBannerClick}
                    iconSize="xs"
                    type="flat"
                    iconName="close"
                    iconColor={colorsPalettes.carbon[300]}
                />
            </AddonsCartRightPart>
        </AddonsCartBannerWrapper>
    );
};
